import { render, staticRenderFns } from "./Presentations.vue?vue&type=template&id=fa34ea38&scoped=true&"
import script from "./Presentations.vue?vue&type=script&lang=js&"
export * from "./Presentations.vue?vue&type=script&lang=js&"
import style0 from "./Presentations.vue?vue&type=style&index=0&id=fa34ea38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa34ea38",
  null
  
)

export default component.exports